import { getDataWithDeduplication } from "../../../../../api/componentAPIs";

const ALL_DRIVERS = '*';

const getDriverPerformanceQueryString = (driverIds) => {
  return driverIds?.length
    ? `&driverIds=${driverIds.map((driverId) => driverId.toUpperCase()).join(',')}`
    : '';
};
export const getDriverPerformanceData = (() => {
    let pendingDriverIds = [];
    let syncedDriverIds = []; //syncedDriverIds will help to restore pendingDrivers list in case of request rejection/failure
    const updateDriverRoutesFailure = (driversToUpdate = []) => {
      // if data fetch failed , restore pending list to update in next call
      pendingDriverIds = [...new Set([...pendingDriverIds, ...driversToUpdate])];
    };
  
    const getLatestQuery = (terminalCode, dispatchDate, originalDriverIdsToUpdate) => () => {
      let driversToUpdate = [
        ...new Set([...pendingDriverIds, ...originalDriverIdsToUpdate, ...syncedDriverIds])
      ]; // Combine pending and original driver IDs and use it to generate latest query

      if (!originalDriverIdsToUpdate.length || pendingDriverIds.includes(ALL_DRIVERS)) {
        driversToUpdate = [];
        syncedDriverIds = [];
      } else {
        syncedDriverIds = [...pendingDriverIds]; // store pending drivers as syncedDrivers to restore in case of rejection of the latest call being made
      }

      pendingDriverIds = []; // reset pending list as its already added to the latest request's query.
      const driversQueryString = getDriverPerformanceQueryString(driversToUpdate);
      return `terminalCode=${terminalCode}&dispatchDate=${dispatchDate}${driversQueryString}`;
    };
  
    return (terminalCode, dispatchDate, driverIds) => {
      if (!driverIds?.length) {
        pendingDriverIds = [ALL_DRIVERS];
        driverIds = [];
      }
      const driversToUpdate = [...new Set(driverIds)];
      return getDataWithDeduplication(
        'DriverPerformance',
        null,
        getLatestQuery(terminalCode, dispatchDate, driversToUpdate) // call getLatestQuery function with original list of driverIds to allow inner function to access it when it is invoked later using closure.
      )
        .then((response) => {
          if (![200, 204].includes(response?.status)) {
            // add rejected request's drivers to pending list.
            updateDriverRoutesFailure(driversToUpdate);
          } else {
            syncedDriverIds = []; //Clear syncedDriverIds only when previous request made with these ids gets resolved.
          }
          return response;
        })
        .catch((err) => {
          // add rejected request's drivers to pending list.
          updateDriverRoutesFailure(driversToUpdate);
          throw err;
        });
    };
  })();
  